import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Firebase from 'firebase';
import firebaseConfig from './firebaseConfig';
Firebase.initializeApp(firebaseConfig);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

